(function () {
  const CART_SELECTOR = '.fmd-cart-icon, [data-instant-action-type="open-cart"], [data-instant-action-type="trigger-cart"]';
  const SEARCH_SELECTOR = '.fmd-search-icon';
  const A11Y_SELECTOR = '.fmd-accessibility-icon';

  function openCartDrawer(trigger) {
    const deadline = Date.now() + 3000;
    (function tick() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(trigger);
        return;
      }
      if (Date.now() < deadline) setTimeout(tick, 100);
    })();
  }

  function openSearchModal() {
    const summary = document.querySelector('details-modal.header__search summary');
    if (summary) {
      summary.click();
      return true;
    }
    window.location.href = '/search';
    return false;
  }

  function toggleAccessibilityPanel() {
    const deadline = Date.now() + 3000;
    (function tick() {
      const w = window.AccessibilityWidget;
      if (w && typeof w.togglePanel === 'function') {
        w.togglePanel();
        return;
      }
      if (Date.now() < deadline) setTimeout(tick, 100);
    })();
  }

  function neutralize(el) {
    el.removeAttribute('href');
    el.removeAttribute('data-instant-action-type');
    el.removeAttribute('data-instant-href');
    el.style.cursor = 'pointer';
  }

  function bind(el, handler) {
    const wrapped = function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      handler(el);
    };
    el.addEventListener('click', wrapped, true);
    el.addEventListener('mousedown', function (e) {
      e.stopImmediatePropagation();
    }, true);
  }

  function wireOnce(el, handler) {
    if (el.dataset.fmdBridgeWired) return;
    el.dataset.fmdBridgeWired = '1';
    neutralize(el);
    bind(el, handler);
  }

  function wireAll() {
    document.querySelectorAll(CART_SELECTOR).forEach(function (el) {
      wireOnce(el, openCartDrawer);
    });
    document.querySelectorAll(SEARCH_SELECTOR).forEach(function (el) {
      wireOnce(el, openSearchModal);
    });
    document.querySelectorAll(A11Y_SELECTOR).forEach(function (el) {
      wireOnce(el, toggleAccessibilityPanel);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const cartTrigger = target.closest(CART_SELECTOR);
      if (cartTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openCartDrawer(cartTrigger);
        return;
      }

      const searchTrigger = target.closest(SEARCH_SELECTOR);
      if (searchTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openSearchModal();
        return;
      }

      const a11yTrigger = target.closest(A11Y_SELECTOR);
      if (a11yTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleAccessibilityPanel();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }

  const observer = new MutationObserver(function () {
    wireAll();
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();

/*
 * Safari-Desktop-Fix für die Mega-Menüs (Hund / Katze / Entdecken).
 *
 * Diese Instant-Dropdowns öffnen nur per Hover (`data-instant-action-on-hover`).
 * Befund aus dem Safari-Live-Test:
 *   - Instant hat den `position:fixed`-Wrapper bereits korrekt positioniert und
 *     vollbreit dimensioniert (Breite via `--instant-reference-width`); er ist
 *     nur per `data-state="closed"` (opacity/visibility/pointer-events) versteckt.
 *   - Ein simples Umschalten auf `data-state="open"` zeigt das Menü sofort an der
 *     richtigen Stelle — KEINE eigene Positionierung/Breite nötig (das hatte
 *     zuvor Chrome zerstört bzw. in Safari die Seite blockiert).
 *   - Der Trigger-Container hat 0 Größe, daher feuert Hover NUR über das sichtbare
 *     Kind -> wir delegieren `mouseover`/`mouseout` auf document-Ebene.
 *   - Instant reagiert nicht auf synthetische Events -> wir setzen `data-state`
 *     selbst.
 *
 * Regeln: NUR `data-state`/`data-instant-state` toggeln. NIE transform setzen.
 * Auf Chrome/Firefox ist das deckungsgleich mit Instants eigener Logik
 * (kein Layout-Eingriff), in Safari ersetzt es den nicht funktionierenden Hover.
 *
 * Ausnahme Positionierung: Instant positioniert den Wrapper LAZY beim ersten
 * eigenen Hover-Handling (inline top/left/min-width/--instant-reference-*).
 * Läuft Instants Handler nicht (das Kunden-Szenario), bliebe der Wrapper
 * unpositioniert und das Menü erschiene oben links mit Inhaltsbreite — die
 * Dropdown-Breite hängt an var(--instant-reference-width). Deshalb repliziert
 * ensurePositioned() exakt Instants eigenes Inline-Schema, aber NUR wenn noch
 * kein `top` gesetzt ist; sobald Instant selbst positioniert (Chrome/FF und
 * funktionierendes Safari), fasst der Fallback nichts an.
 */
(function () {
  var TRIGGER_SELECTOR = '[data-instant-action-type="open-dropdown"][data-instant-action-on-hover]';
  var CLOSE_DELAY = 200;
  var closeTimer = null;

  function wrapperFor(trigger) {
    var id = trigger.getAttribute('data-instant-action-id');
    var inner = id ? document.querySelector('.i' + id) : null;
    return inner ? inner.closest('.instant-dropdown--wrapper') : null;
  }
  function ensurePositioned(trigger, wrapper) {
    if ((wrapper.getAttribute('style') || '').indexOf('top:') !== -1) return;
    var header = document.getElementById('fmd-sticky-header');
    if (!header) return;
    // #fmd-sticky-header hat will-change:transform und ist damit der Containing
    // Block des position:fixed-Wrappers -> top ist relativ zum Header, also
    // schlicht dessen Höhe (Topbar + Nav-Zeile).
    var headerHeight = Math.round(header.getBoundingClientRect().height);
    var vw = document.documentElement.clientWidth;
    wrapper.style.left = '0px';
    wrapper.style.top = headerHeight + 'px';
    wrapper.style.minWidth = vw + 'px';
    wrapper.style.setProperty('--instant-reference-width', vw + 'px');
    var row = trigger.parentElement;
    while (row && row !== header && getComputedStyle(row).position !== 'sticky') row = row.parentElement;
    if (row && row !== header) {
      var rowHeight = Math.round(row.getBoundingClientRect().height);
      wrapper.style.minHeight = rowHeight + 'px';
      wrapper.style.setProperty('--instant-reference-height', rowHeight + 'px');
    }
  }
  function setOpen(trigger, open) {
    trigger.setAttribute('data-instant-state', open ? 'active' : 'inactive');
    var wrapper = wrapperFor(trigger);
    if (wrapper) {
      if (open) ensurePositioned(trigger, wrapper);
      wrapper.setAttribute('data-state', open ? 'open' : 'closed');
    }
  }
  function anyOpen() {
    return document.querySelector(TRIGGER_SELECTOR + '[data-instant-state="active"]');
  }
  function closeAll(except) {
    document.querySelectorAll(TRIGGER_SELECTOR).forEach(function (t) {
      if (t !== except && t.getAttribute('data-instant-state') === 'active') setOpen(t, false);
    });
  }
  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }
  function scheduleCloseAll() {
    cancelClose();
    closeTimer = setTimeout(function () {
      closeAll(null);
    }, CLOSE_DELAY);
  }

  // Hover via Delegation (Trigger-Container hat 0 Größe; mouseover bubblet vom
  // sichtbaren Kind hoch und feuert auch in Safari).
  document.addEventListener('mouseover', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var trigger = target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      cancelClose();
      if (trigger.getAttribute('data-instant-state') !== 'active') {
        closeAll(trigger);
        setOpen(trigger, true);
      }
      return;
    }
    if (target.closest('.instant-dropdown--wrapper')) {
      cancelClose();
      return;
    }
    if (anyOpen()) scheduleCloseAll();
  });

  // Klick = verlässlicher Pfad (z. B. wenn Hover gar nicht feuert).
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var trigger = target.closest(TRIGGER_SELECTOR);
      if (trigger) {
        // Navigations-Link im Trigger (z. B. "Hund" -> Kollektion) navigieren lassen.
        var link = target.closest('a[href]');
        if (link && trigger.contains(link)) return;
        event.preventDefault();
        event.stopPropagation();
        var open = trigger.getAttribute('data-instant-state') === 'active';
        closeAll(trigger);
        setOpen(trigger, !open);
        return;
      }
      if (!target.closest('.instant-dropdown--wrapper')) closeAll(null);
    },
    true
  );

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' || event.code === 'Escape') closeAll(null);
  });
})();
